import { Outlet, useLocation } from 'react-router-dom';
import { Stack } from '@repletoryreach/sdk-ui';
import { PageHeader } from '@repletoryreach/sdk-ui/data-display';
import { useT } from '../../../i18n/I18nProvider';

/**
 * The settings shell. It carries the hub's header and nothing else.
 *
 * There used to be a 220px section sidebar beside every child route, listing
 * the same seven destinations the hub already lists. The reference designs
 * have no such column: a settings page is full width, and the way back up is
 * the header breadcrumb, which already renders "Admin › Settings › Profile"
 * with the middle crumb linking to the hub (see `app/breadcrumbs.ts`). Taking
 * the column out gives the forms and tables underneath the width the designs
 * draw them at, and stops the console printing its own menu twice on the one
 * page that is itself a menu.
 */
export default function SettingsLayout() {
  const t = useT();
  const { pathname } = useLocation();

  // Only the hub takes its header from here. Every child route brings its own,
  // so a child rendering inside this layout must not find a second title above it.
  const isHub = pathname === '/settings' || pathname === '/settings/';

  return (
    <Stack gap="lg">
      {isHub && <PageHeader title={t('common.settings')} description={t('settings.layout.description')} />}
      <Outlet />
    </Stack>
  );
}
